export default hostname => {
  const defaultParams = {expires: 10, path: '/', sameSite: 'lax'};

  if (hostname.includes('.xsolla.com')) {
    return {...defaultParams, domain: '.xsolla.com'};
  }
  if (hostname.includes('.srv.local')) {
    return {...defaultParams, domain: '.srv.local'};
  }
  return defaultParams;
};
